// extracted by mini-css-extract-plugin
export default {"contactLink":"DirectContact_contactLink__e60oh"};